import { motion } from "framer-motion";
import SectionHeading from "@/components/common/SectionHeading";
import { PROCESS_STEPS } from "@/lib/data";

export default function RecruitmentProcess() {
  return (
    <section className="py-24 sm:py-32" data-testid="recruitment-process">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHeading
          eyebrow="Placement Process"
          title="Seven deliberate steps. Zero guesswork."
          sub="From registration to onboarding, a dedicated senior recruiter owns your journey end-to-end."
        />

        <div className="relative mt-16">
          {/* Vertical line */}
          <div className="absolute left-6 md:left-1/2 md:-translate-x-1/2 top-2 bottom-2 w-px bg-gradient-to-b from-[#1E3A8A] via-[#10B981] to-transparent" />

          <div className="space-y-8 md:space-y-14">
            {PROCESS_STEPS.map((step, i) => (
              <motion.div
                key={step.n}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.4 }}
                transition={{ duration: 0.55, delay: i * 0.05 }}
                className={`relative grid md:grid-cols-2 gap-6 md:gap-16 items-center ${
                  i % 2 === 1 ? "md:[&>*:first-child]:order-2" : ""
                }`}
              >
                {/* content side */}
                <div className={`pl-16 md:pl-0 ${i % 2 === 0 ? "md:pr-16 md:text-right" : "md:pl-16"}`}>
                  <p className="font-inter text-[11px] uppercase tracking-[0.24em] text-[#10B981] font-semibold mb-2">Step {step.n}</p>
                  <p className="font-poppins text-white text-2xl font-semibold mb-2">{step.title}</p>
                  <p className="font-inter text-white/55 leading-relaxed">{step.desc}</p>
                </div>

                {/* dot */}
                <div className="absolute left-6 md:left-1/2 md:-translate-x-1/2 top-0 md:top-1/2 md:-translate-y-1/2">
                  <div className="relative w-6 h-6 rounded-full flex items-center justify-center"
                    style={{ background: "linear-gradient(135deg, #1E3A8A, #10B981)" }}>
                    <span className="w-2 h-2 rounded-full bg-white" />
                    <span className="absolute inline-flex h-full w-full rounded-full opacity-30 animate-ping"
                      style={{ background: "#10B981" }} />
                  </div>
                </div>

                {/* spacer */}
                <div />
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
